import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUpperCase]'
})
export class UpperCaseDirective {

  constructor(private readonly ngControl: NgControl) {}

  @HostListener('input', ['$event']) 
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.toUpperCase();
    this.ngControl.control?.setValue(value, { emitEvent: false });
  }
}
